export default {
  validateCredentials: 'Anmeldeinformationen testen',
  credentialsInvalidMessage: 'Die Anmeldeinformationen sind falsch.',
  credentialsValidMessage: 'Die Anmeldeinformationen sind valide.',
};
